import { useQuery } from "@tanstack/react-query";
import { GET_SERVER_TIME, getServerTime } from "..";

export const useServerTime = ({ load = false }) => {
  return useQuery({
    queryKey: [GET_SERVER_TIME],
    queryFn: () => getServerTime(),
    enabled: load,
  });
};
